export enum NotificationID {
    EventState = 'EVENT_STATE',
    EventDataError = 'EVENT_DATA_ERROR',
}

export interface HistoryState {
    participantId?: string;
}

export enum TestID {
    EventOverview = 'event-overview',
}

export enum StorageKeyID {
    EVENT_DURATION_HIDE_TIME = 'eventDurationHideTime',
}
